"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xorDecrypt = xorDecrypt;
exports.xorEncrypt = xorEncrypt;
function xorTransform(data, key) {
    if (key.length === 0) {
        throw new Error("XOR key must not be empty.");
    }
    const result = new Uint8Array(data.length);
    for (let index = 0; index < data.length; index += 1) {
        result[index] = data[index] ^ key[index % key.length];
    }
    return result;
}
function xorDecrypt(data, key) {
    return xorTransform(data, key);
}
function xorEncrypt(data, key) {
    return xorTransform(data, key);
}
//# sourceMappingURL=crypto.js.map